export const courseCompletionModalSx = {
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 370, sm: 420, md: 500 },
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "50px",
    px: 5,
    py: 5,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
  },
  closeBox: {
    position: "absolute",
    top: 20,
    right: 20,
    cursor: "pointer",
  },
  titleText: {
    fontWeight: "bold",
    textAlign: "center",
  },
  bodyText: {
    variant: "body1",
    textAlign: "center",
  },
};
